import React from 'react';
import {
    CustomTableRowsProps,
    ContentLoader,
} from '@dev/ee-components';
import { useCheckoutParamsFromUrl } from '@/components/Checkouts/hooks/useRequestParams';
import { CheckoutListState } from '@/store/checkouts/types';


export const useLoadingCheckouts = (checkouts: CheckoutListState) => {
    const urlParams = useCheckoutParamsFromUrl();
    if (!checkouts?.loadingTemplates) {
        return
    }

    const perPage = urlParams.limit || 5;
    const rows: CustomTableRowsProps[] = new Array(perPage).fill(1);
    return rows.map((): CustomTableRowsProps => (
        {
            thumbnail: <ContentLoader mode="row" height={70} width={70} />,
            name: <ContentLoader mode="row" height={20} />,
            status: <ContentLoader mode="row" height={20} />,
            icon: <ContentLoader mode="row" height={20} />,
        }
    ))
}